module.exports = __webpack_public_path__ + "static/media/careers_hero-mobile.2b324bc4.jpg";